import Vue from 'vue'
import vuex from 'vuex'

import login from './login'
import common from './common'
import api from './api'
import battle from './battle'
import useData from './useData'
import test from './test'
import superQuiz from './superQuiz'
import proctor from './proctor'

Vue.use(vuex)

export default new vuex.Store({
  modules: {
    login,       // 和登录挂钩,
    useData,
    common,      // 全局的公共变量
    api,         // 公共请求，解决请求过了就不需要再请求一遍
    battle,       // 对战系统
    test,       // 监考
    superQuiz,   // sq
    proctor     // 监考系统
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js